/**
 * Utility functions for saving and loading score data using localStorage
 * with the "fallin_well_" prefix to avoid conflicts with other games.
 */
/**
 * Saves data to localStorage.
 * @param ref The data reference key
 * @param data The data to save
 */
export function saveData(ref, data) {
    const key = `fallin_well_${ref}`;
    localStorage.setItem(key, JSON.stringify(data));
}
/**
 * Loads data from localStorage.
 * @param ref The data reference key
 * @returns The data if found, otherwise null
 */
export function loadData(ref) {
    const key = `fallin_well_${ref}`;
    const data = localStorage.getItem(key);
    if (data) {
        return JSON.parse(data);
    }
    return null;
}
